(function () {
    var componentId = 'clinicHealthScreeningDashboardSubmitted';
    var app = angular.module('app');

    function controller($sce, $scope, healthScreeningDashboardSvc) {
        function init() {
            vm.getHealthScreeningClaims();

            $scope.$on('tickerEvent', function () {
                if (!vm.loading) {
                    vm.getHealthScreeningClaimsSilent();
                }
            });
        }
        var vm = this;
        vm.loading = 0;
        vm.ticketList = [];
        vm.activeSort = 'sortByLatestUpdated';
        vm.skipCount = 0;
        vm.maxResultCount = 5;

        vm.sortFunction = function (sort) {
            vm.activeSort = sort;

            switch (sort) {
                case 'sortByEarliestUpdated':
                    vm.ticketList = _.orderBy(vm.ticketList, ['claimDate'], ['asc']);
                    break;
                case 'sortByLatestUpdated':
                    vm.ticketList = _.orderBy(vm.ticketList, ['claimDate'], ['desc']);
                    break;
            }
        }

        vm.processClaims = function (data) {
            _.each(data, function (claim) {
                vm.ticketList.push({
                    patientName: claim.employeeName,
                    nationalId: claim.employeeNationalId,
                    subsidiaryName: claim.employeeSubsidiary,
                    claimNumber: claim.claimNumber,
                    claimDate: claim.claimDate,
                    guaranteeLetterNumber: claim.letterNumber
                });
            });
        };

        vm.getHealthScreeningClaims = function () {
            vm.hasMore = true;

            vm.loading++;
            healthScreeningDashboardSvc.getClaims({
                "status": [2, 4],
                "requestStatus": [1],
                "queryStatus": [null, 2, 3],
                skipCount: vm.skipCount,
                maxResultCount: vm.maxResultCount
            }).success(function (data) {
                // Process claims.

                vm.processClaims(data.items);

                // Sort tickets.

                vm.sortFunction(vm.activeSort);

                vm.hasMore = vm.ticketList.length < data.totalCount;
                vm.skipCount += vm.maxResultCount;
            }).finally(function (e) {
                vm.loading--;
            });
        };

        vm.getHealthScreeningClaimsSilent = function () {
            healthScreeningDashboardSvc.getClaims({
                "status": [2, 4],
                "requestStatus": [1],
                "queryStatus": [null, 2, 3],
                skipCount: 0,
                maxResultCount: (vm.ticketList.length > vm.maxResultCount) ? vm.ticketList.length : vm.maxResultCount
            }).success(function (data) {
                vm.ticketList = [];

                // Process claims.

                vm.processClaims(data.items);

                // Sort tickets.

                vm.sortFunction(vm.activeSort);

                // Check if there are more tickets.

                vm.hasMore = vm.ticketList.length < data.totalCount;
            }).finally(function (e) {
                // EMPTY.
            });
        };

        init();
    }

    app.component(componentId, {
        templateUrl: require('/App/clinic/views/healthScreening/dashboard/submitted/submitted.component.html'),
        controller: ['$sce', '$scope', 'abp.services.app.healthScreeningDashboard', controller],
        controllerAs: 'vm',
        bindings: {
            timeZoneId: '<'
        }
    });
})();
